// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.audio-trimmer_absolute_ADSPM {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Force the browser to paint separately to avoid composite cost with waveform */
  transform: translateZ(0);
}

.audio-trimmer_selector_iKR5p {
  cursor: pointer;
}

.audio-trimmer_trim-background_KsrTj {
  cursor: pointer;
  touch-action: none;
}

.audio-trimmer_trim-background-mask_8N24O {
  border: 1px solid var(--red-tertiary);
  opacity: 0.5;

  background: repeating-linear-gradient(
    45deg,
    var(--red-primary),
    var(--red-primary) 10px,
    var(--red-tertiary) 10px,
    var(--red-tertiary) calc(2 * 10px)
  );
}

.audio-trimmer_selection-background_hVvWC {
  background: var(--looks-secondary);
  opacity: 0.5;
}

.audio-trimmer_start-trim-background_DuZTO .audio-trimmer_trim-background-mask_8N24O {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.audio-trimmer_end-trim-background_NiFqX .audio-trimmer_trim-background-mask_8N24O {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.audio-trimmer_trim-line_aO1CR {
  position: absolute;
  top: 0;
  width: 0px;
  height: 100%;
  border: 1px solid var(--red-tertiary);
}

.audio-trimmer_selector_iKR5p .audio-trimmer_trim-line_aO1CR {
  border: 1px solid var(--looks-secondary);
}

.audio-trimmer_playhead-container_swgsl {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.audio-trimmer_playhead_qRYeq {
  /*
        Even though playhead is just a line, it is 100% width (the width of the waveform)
        so that we can use transform: translateX() using percentages.
    */
  width: 100%;
  height: 100%;
  border-left: 1px solid var(--looks-secondary);
  border-top: none;
  border-bottom: none;
  border-right: none;
}

.audio-trimmer_right-handle_YhId4 {
  transform: scaleX(-1);
}

.audio-trimmer_selector_iKR5p .audio-trimmer_left-handle_z3PmZ {
  left: -1px;
}

.audio-trimmer_selector_iKR5p .audio-trimmer_right-handle_YhId4 {
  right: -1px;
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_left-handle_z3PmZ {
  right: -1px;
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_right-handle_YhId4 {
  left: -1px;
}

.audio-trimmer_trim-handle_vVOON {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 0;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_trim-handle_vVOON {
  filter: hue-rotate(-240deg) brightness(1.35);
}

.audio-trimmer_trim-handle_vVOON img {
  position: absolute;
  width: 30px;
  height: 30px;
  left: calc(3px * 1.5);

  /* Make sure image dragging isn't triggered */
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  user-drag: none;
  -webkit-user-drag: none; /* Autoprefixer doesn't seem to work for this */

  transition: 0.2s;
}

.audio-trimmer_top-trim-handle_P76zB {
  top: calc(-30px + 3px);
}

.audio-trimmer_bottom-trim-handle_AptpN {
  bottom: calc(-30px + 3px);
}

.audio-trimmer_top-trim-handle_P76zB img {
  transform: scaleY(-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/audio-trimmer/audio-trimmer.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,gFAAgF;EAChF,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,YAAY;;EAEZ;;;;;;GAMC;AACH;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;;;KAGG;EACH,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB,6CAA6C;EAC7C,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;EACf,uBAAuB,EAAE,+CAA+C;;EAExE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.absolute {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  /* Force the browser to paint separately to avoid composite cost with waveform */\n  transform: translateZ(0);\n}\n\n.selector {\n  cursor: pointer;\n}\n\n.trim-background {\n  cursor: pointer;\n  touch-action: none;\n}\n\n.trim-background-mask {\n  border: 1px solid var(--red-tertiary);\n  opacity: 0.5;\n\n  background: repeating-linear-gradient(\n    45deg,\n    var(--red-primary),\n    var(--red-primary) 10px,\n    var(--red-tertiary) 10px,\n    var(--red-tertiary) calc(2 * 10px)\n  );\n}\n\n.selection-background {\n  background: var(--looks-secondary);\n  opacity: 0.5;\n}\n\n.start-trim-background .trim-background-mask {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.end-trim-background .trim-background-mask {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.trim-line {\n  position: absolute;\n  top: 0;\n  width: 0px;\n  height: 100%;\n  border: 1px solid var(--red-tertiary);\n}\n\n.selector .trim-line {\n  border: 1px solid var(--looks-secondary);\n}\n\n.playhead-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.playhead {\n  /*\n        Even though playhead is just a line, it is 100% width (the width of the waveform)\n        so that we can use transform: translateX() using percentages.\n    */\n  width: 100%;\n  height: 100%;\n  border-left: 1px solid var(--looks-secondary);\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n}\n\n.right-handle {\n  transform: scaleX(-1);\n}\n\n.selector .left-handle {\n  left: -1px;\n}\n\n.selector .right-handle {\n  right: -1px;\n}\n\n.trimmer .left-handle {\n  right: -1px;\n}\n\n.trimmer .right-handle {\n  left: -1px;\n}\n\n.trim-handle {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  right: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.trimmer .trim-handle {\n  filter: hue-rotate(-240deg) brightness(1.35);\n}\n\n.trim-handle img {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  left: calc(3px * 1.5);\n\n  /* Make sure image dragging isn't triggered */\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  user-drag: none;\n  -webkit-user-drag: none; /* Autoprefixer doesn't seem to work for this */\n\n  transition: 0.2s;\n}\n\n.top-trim-handle {\n  top: calc(-30px + 3px);\n}\n\n.bottom-trim-handle {\n  bottom: calc(-30px + 3px);\n}\n\n.top-trim-handle img {\n  transform: scaleY(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"absolute": `audio-trimmer_absolute_ADSPM`,
	"selector": `audio-trimmer_selector_iKR5p`,
	"trim-background": `audio-trimmer_trim-background_KsrTj`,
	"trimBackground": `audio-trimmer_trim-background_KsrTj`,
	"trim-background-mask": `audio-trimmer_trim-background-mask_8N24O`,
	"trimBackgroundMask": `audio-trimmer_trim-background-mask_8N24O`,
	"selection-background": `audio-trimmer_selection-background_hVvWC`,
	"selectionBackground": `audio-trimmer_selection-background_hVvWC`,
	"start-trim-background": `audio-trimmer_start-trim-background_DuZTO`,
	"startTrimBackground": `audio-trimmer_start-trim-background_DuZTO`,
	"end-trim-background": `audio-trimmer_end-trim-background_NiFqX`,
	"endTrimBackground": `audio-trimmer_end-trim-background_NiFqX`,
	"trim-line": `audio-trimmer_trim-line_aO1CR`,
	"trimLine": `audio-trimmer_trim-line_aO1CR`,
	"playhead-container": `audio-trimmer_playhead-container_swgsl`,
	"playheadContainer": `audio-trimmer_playhead-container_swgsl`,
	"playhead": `audio-trimmer_playhead_qRYeq`,
	"right-handle": `audio-trimmer_right-handle_YhId4`,
	"rightHandle": `audio-trimmer_right-handle_YhId4`,
	"left-handle": `audio-trimmer_left-handle_z3PmZ`,
	"leftHandle": `audio-trimmer_left-handle_z3PmZ`,
	"trimmer": `audio-trimmer_trimmer_Y4lVW`,
	"trim-handle": `audio-trimmer_trim-handle_vVOON`,
	"trimHandle": `audio-trimmer_trim-handle_vVOON`,
	"top-trim-handle": `audio-trimmer_top-trim-handle_P76zB`,
	"topTrimHandle": `audio-trimmer_top-trim-handle_P76zB`,
	"bottom-trim-handle": `audio-trimmer_bottom-trim-handle_AptpN`,
	"bottomTrimHandle": `audio-trimmer_bottom-trim-handle_AptpN`
};
export default ___CSS_LOADER_EXPORT___;
